import { Capacitor } from '@capacitor/core';
import { Network } from '@capacitor/network';

const MAX_WAIT_MS = 4000;
const POLL_MS = 150;
const SETTLE_MS = 600;

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * On native, the gallery/camera briefly backgrounds the app and Capacitor may
 * report disconnected. Wait until the network is back before firing uploads.
 */
export async function waitForStableNetworkAfterPicker(): Promise<void> {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  const startedAt = Date.now();

  while (Date.now() - startedAt < MAX_WAIT_MS) {
    const status = await Network.getStatus();
    if (status.connected) {
      await sleep(SETTLE_MS);
      const recheck = await Network.getStatus();
      if (recheck.connected) {
        return;
      }
    }
    await sleep(POLL_MS);
  }
}
